<template>
<div class="main-layout">
    <Header></Header>
    <Content id="content"></Content>
</div>

</template>

<script>
// import {Footer,Header,Content} from './subViews'

import Header from "./subViews/Header.vue";
import Content from "./subViews/Content.vue";
export default {
 name: "MainLayout",
  components: {
    Header,
    Content
  },
}
</script>

<style socped>
/* #content {padding-top: 128px;} */
</style>



// WEBPACK FOOTER //
// src/components/dashboard/MainLayout.vue